"use client";
import React from "react";
import { Button } from "@headlessui/react";

const ButtonCV = () => {
  return (
    <div className="flex gap-4 mt-5">
      <Button
        className="px-4 py-2 text-sm text-white rounded data-active:bg-sky-700 data-hover:bg-sky-500 bg-sky-600"
        onClick={() => {
          const link = document.createElement("a");
          link.href = "/assets/globals/files/cv.pdf";
          link.download = "cv.pdf";
          link.click();
        }}
      >
        Download CV - Indonesia
      </Button>
      <Button
        className="px-4 py-2 text-sm text-white rounded data-active:bg-sky-700 data-hover:bg-sky-500 bg-sky-600"
        onClick={() => {
          const link = document.createElement("a");
          link.href = "/assets/globals/files/cv-en.pdf";
          link.download = "cv-en.pdf";
          link.click();
        }}
      >
        Download CV - English
      </Button>
    </div>
  );
};

export default ButtonCV;
